import React, { useCallback, useMemo } from 'react';
import { Box, Inscription, PriceInput } from '@common-fe/common-fe';

import { useCategorySpendLimitsStore } from '../stores';
import { useSpendLimitsModalStore } from '../stores/useSpendLimitsModal.store';

const ERROR_TEXT = 'Spend limit must be greater than 0';

interface Props {
  categoryType: string;
}

const testId = 'SpendLimitItem';

export const SpendLimitItem: React.FC<Props> = ({ categoryType }) => {
  const draftSpendLimits = useCategorySpendLimitsStore((state) => state.draftSpendLimits);
  const handleUpdateDraftSpendLimit = useCategorySpendLimitsStore((state) => state.handleUpdateDraftSpendLimit);
  const isSubmitted = useSpendLimitsModalStore((state) => state.isSubmitted);

  const value = useMemo(
    () => draftSpendLimits.find((item) => item.category_type === categoryType)?.category_spend_limit ?? '',
    [draftSpendLimits, categoryType]
  );

  const errorText = useMemo(() => {
    if (isSubmitted && value !== '' && parseFloat(value) <= 0) {
      return ERROR_TEXT;
    }
    return '';
  }, [isSubmitted, value]);

  const handleChange = useCallback(
    (val: string) => {
      handleUpdateDraftSpendLimit(categoryType, val);
    },
    [categoryType, handleUpdateDraftSpendLimit]
  );

  return (
    <Box
      direction="row"
      justify="between"
      data-testid={`${testId}_${categoryType}`}
    >
      <Box width="244px" justify="center">
        <Inscription
          weight={700}
          color="textBody"
          data-testid={`${testId}_${categoryType}_category`}
          lineHeight="20px"
        >
          {categoryType}
        </Inscription>
      </Box>

      <Box width="320px">
        <PriceInput
          testId={`${testId}_${categoryType}_input`}
          onChange={handleChange}
          name={`spend-limit-${categoryType}`}
          value={value}
          placeholder="Unlimited spend"
          errorText={errorText}
        />
      </Box>
    </Box>
  );
};
